import React, { useContext } from 'react';

import { ContentContext } from 'Components/hooks/context';
import RegionLink from 'Components/common/RegionLink';
import SmartText from '@reuters-graphics/react-smart-text';
import groupBy from 'lodash/groupBy';
import roundDown from 'Utils/roundDown';

const getShareOfDaily = (cases, topRegion) => {
  const groupedByRegion = groupBy(cases, 'region');
  const latestReportingDates = [];
  // Get latest dates where more than 90% of countries in a region are logged
  for (const region in groupedByRegion) {
    const { date } = groupedByRegion[region].filter(a => a.reporting[1] / a.reporting[0] > 0.9)[0];
    latestReportingDates.push(date);
  }

  // Sort latest dates earliest to latest
  latestReportingDates.sort((a, b) => new Date(a) - new Date(b));

  // Use earliest latest date :)
  const latestReportingDate = latestReportingDates[0];

  let totalReportingForLatestDate = 0;
  let topRegionLatest = 0;
  for (const region in groupedByRegion) {
    const { count } = groupedByRegion[region].find(a => a.date === latestReportingDate);
    if (region === topRegion) topRegionLatest = count;
    totalReportingForLatestDate += count;
  }

  return topRegionLatest / totalReportingForLatestDate;
};

const getRegionTotal = (cases, topRegion) => cases
  .filter(c => c.region === topRegion)
  .reduce((a, c) => a + c.count, 0);

const getDaysForLastMillion = (cases, topRegion) => {
  const regionCases = cases
    .filter(c => c.region === topRegion)
    .filter(a => a.reporting[1] / a.reporting[0] > 0.9); // Complete days
  regionCases.sort((a, b) => new Date(b.date) - new Date(a.date));

  const oneDay = 24 * 60 * 60 * 1000;
  const latestDate = new Date(regionCases[0].date);
  let i = 0;
  let runningTotal = 0;
  while (runningTotal < 1000000) {
    runningTotal += regionCases[i].count;
    i += 1;
  }

  const dateMinusMillion = new Date(regionCases[i - 1].date);

  const daysForLastMillion = Math.ceil((latestDate - dateMinusMillion) / oneDay);

  return daysForLastMillion;
};

const Text = (props) => {
  const { cases, locale, region } = props;
  const content = useContext(ContentContext).template.byRegion;
  // temporary
  if (region === 'oceania') return null;
  const regionShareOfLatestDate = getShareOfDaily(cases, region);
  const regionTotal = getRegionTotal(cases, region);
  const daysForLastMillion = getDaysForLastMillion(cases, region);

  return regionShareOfLatestDate < 0.05 ? (
    <SmartText
      source={content.introShort}
      context={{
        region: <RegionLink region={region} locale={locale} />,
        days: (daysForLastMillion).toLocaleString(locale),
        total: roundDown(regionTotal).toLocaleString(locale),
      }}
      multiline
    />
  ) : (
    <SmartText
      source={content.intro}
      context={{
        region: <RegionLink region={region} locale={locale} />,
        share: Math.floor(regionShareOfLatestDate * 100).toLocaleString(locale),
        days: (daysForLastMillion).toLocaleString(locale),
        total: roundDown(regionTotal).toLocaleString(locale),
      }}
      multiline
    />
  );
};

export default Text;
